import React, { ChangeEvent, useState } from "react";
import {
  Installation,
  Organization,
  Video,
  VideoCataloguesDto,
} from "../common/ObjectTypes";
import { AddIcon, ClearSearchIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Pagination from "../common/Pagination";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../helpers/authHeader";
import tailwindClassnames from "../common/TaildwindClassnames";

type InstallationsListTypes = {
  installations: Installation[];
  videoCatalogues: VideoCataloguesDto[];
  videos: Video[];
  organizations: Organization[];
  onSelectInstallation: Function;
  onClickAdd: Function;
  onDelete: Function;
  pageCount: number;
  pageSize: number;
  totalCount: number;
  handlePageClick: (selectedItem: { selected: number }) => void;
  reloadPage: boolean;
  recordStart: number;
  recordEnd: number;
  onSearch: Function;
  onChangeSearch: Function;
  onClearSearch: Function;
  searchQuery: any;
  loading: boolean;
};

const InstallationsList = ({
  installations,
  videoCatalogues,
  videos,
  organizations,
  onSelectInstallation,
  onClickAdd,
  pageCount,
  pageSize,
  totalCount,
  handlePageClick,
  reloadPage,
  recordStart,
  recordEnd,
  searchQuery,
  onSearch,
  onClearSearch,
  onChangeSearch,
  // subStr,
  loading,
}: InstallationsListTypes) => {
  const currentUser = getCurrentUser();

  const getCatalogueNameById = (id: any) => {
    let catalogueName = videoCatalogues?.find(
      (catalogue) => catalogue.videoCatalogueId === id
    );
    return catalogueName?.name || null;
  };
  const getVideoNameById = (id: any) => {
    let videoName = videos?.find((video) => video.videoId === id);
    return videoName?.name || null;
  };
  const getOrgNameById = (id: any) => {
    let orgName = organizations?.find((org) => org.organizationId === id);
    return orgName?.name || null;
  };

  return (
    <div className="p-6">
      {/* List */}
      <div className="flex flex-row justify-between">
        <h1 className={tailwindClassnames.tableTitle}>Installations</h1>
      </div>
      <div className="flex flex-row items-center mt-4">
        <div className="flex flex-row mr-auto w-1/3">
          <TextInput
            name=""
            label=""
            onChange={onChangeSearch}
            value={searchQuery.name}
            placeholder="Filter by name"
            error={null}
            initialFocus={false}
            className={tailwindClassnames.searchTextInput}
            disabled={false}
            type=""
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
          />
          <button
            onClick={() => onSearch()}
            className={tailwindClassnames.searchButton}
          >
            Search
          </button>
          <button
            onClick={() => onClearSearch()}
            className={tailwindClassnames.searchButton}
          >
            <ClearSearchIcon />
          </button>
        </div>
        <Link
          to="/installation/add"
          className={tailwindClassnames.lookupButton}
        >
          Add
        </Link>
      </div>
      {/* List */}
      <table className={tailwindClassnames.tableContainer}>
        <thead className={tailwindClassnames.tableHead}>
          <tr>
            <th className={tailwindClassnames.tableHeadText}>Name</th>
            <th className={tailwindClassnames.tableHeadText}>
              Global Start LatLong{" "}
            </th>
            <th className={tailwindClassnames.tableHeadText}>Startup Video</th>
            <th className={tailwindClassnames.tableHeadText}>
              Video Catalogue
            </th>
            <th className={tailwindClassnames.tableHeadText}>Organization</th>
          </tr>
        </thead>
        <tbody>
          {installations.map((installation: Installation, index: number) => {
            const rowClass =
              index % 2 === 0 ? "bg-grayScale-200" : "bg-grayScale-100";
            return (
              <tr
                key={installation.installationId}
                className={rowClass + tailwindClassnames.tableBody}
                onClick={() =>
                  onSelectInstallation(installation.installationId)
                }
              >
                <td className={tailwindClassnames.tableBodyText}>
                  {installation.name}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {installation.globeStartLat +
                    ", " +
                    installation.globeStartLong}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {getVideoNameById(installation.startupVideoId)}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {getCatalogueNameById(installation.videoCatalogueId)}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {getOrgNameById(installation.organizationId)}{" "}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Pagination
        handlePageClick={handlePageClick}
        pageCount={pageCount}
        recordStart={recordStart}
        recordEnd={recordEnd}
        totalCount={totalCount}
        loading={loading}
        pageSize={searchQuery.pageSize}
        selectPage={false}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default InstallationsList;
